export default {
  title: 'Préférences de traitement des renseignements personnels',
  modifyButtonLabel: 'Modifier',
  accepted: 'Accepté',
  refuse: 'Refusé',
};
